import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalButton, ModalHeader, Wrapper, WrapperText } from './styled';
import { Text } from '@/components/common';
import { IconError } from '@/components/icons';
import { CONTACT_EMAIL } from '@/utils/constant';

const SomethingWentWrongModal: React.FC<any> = ({ closeModal }) => {
  const { t } = useTranslation();

  const handleClose = () => {
    window.location.href = CONTACT_EMAIL;
    closeModal();
  };

  return (
    <Wrapper>
      <ModalHeader color="primary" variant="title" size="26" style={{ marginBottom: 16 }}>
        <IconError width={40} height={40} />       
      </ModalHeader>
      <WrapperText>
        <Text
          color="primary"
          variant="titleModal"
          style={{ margin: '0px auto 16px auto', maxWidth: '250', width: '100%', textAlign: 'center' }}
        >
          {t('SOMETHING_WENT_WRONG_TITLE')}
        </Text>
        <Text color="secondary" variant="content" size="15">
          {t('SOMETHING_WENT_WRONG_MESSAGE')}
        </Text>
      </WrapperText>
      <ModalButton variant="contained" color="dark" onClick={handleClose}>
        {t('CONTACT_US')}
      </ModalButton>
    </Wrapper>
  );
};

export default SomethingWentWrongModal;
